'use client';
import { StateCreator } from 'zustand/index';
import { CalendarStore } from '@/hooks/use-calendar-store';
import { SettingsState } from '@/types/settings';

export type SettingStore = {
  settings: SettingsState;
  toggleSetting: (key: keyof SettingsState) => void;
  setSetting: (key: keyof SettingsState, value: boolean | number) => void;
};

export const initialSettings: SettingsState = {
  lazyLoading: false,
  doubleBookings: true,
  resourceGap: false,
  lazyLoadingThreshold: 5,
  tradeLabels: true,
  groupLabels: false,
  globalRequirement: false,
  projectRequirement: true,
  summary: false,
  projectSummary: false,
  balance: true,
  hideWeekends: true,
  manualSort: false,
  capacityBadge: false,
  showHiddenProjects: false,
  showHiddenResources: false,
  categoryLabels: true,
  lazyLoadEvents: false,
  lazyLoadSummary: true,
};

export const createSettingSlice: StateCreator<Partial<CalendarStore> & SettingStore> = (set) => ({
  settings: initialSettings,
  setSetting: (key: keyof SettingsState, value: boolean | number) => {
    set((state) => {
      const newSettings = {
        ...state.settings,
        [key]: value,
      };

      return {
        ...state,
        settings: newSettings,
      };
    });
  },
  toggleSetting: (key: keyof SettingsState) => {
    set((state) => {
      const newSettings = {
        ...state.settings,
        [key]: !state.settings[key],
      };

      return {
        ...state,
        settings: newSettings,
      };
    });
  },
});
